import React from 'react';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {classes} from './Body.st.css';
import {CartItems} from '../../../../../common/components/CartItems/CartItems';
import {Text, Divider} from 'wix-ui-tpa/cssVars';
import settingsParams from '../../../settingsParams';
import stylesParams from '../../../stylesParams';
import {useBooleanStyleForAnyBreakpoint} from '../../../../../common/useBooleanStyleForAnyBreakpoint';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';
import {Coupon} from '../../../../../common/components/Coupon/Coupon';

export enum BodyDataHooks {
  emptyState = 'BodyDataHooks.emptyState',
  divider = 'BodyDataHooks.divider',
}

export interface BodyProps {
  onRemoveItem: () => void;
}

export const Body = ({onRemoveItem}: BodyProps) => {
  const {shouldRenderEmptyState, sideCartElementsVisibilityInCss, sideCartCouponAndNote} =
    useControllerProps().cartStore;
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const {getBooleanStyle} = useBooleanStyleForAnyBreakpoint();

  const showQuantityBySettings = getBooleanStyle(
    stylesParams.CART_ITEM_QUANTITY_COUNTER_VISIBILITY,
    sideCartElementsVisibilityInCss
  );
  const showThumbnailBySettings = getBooleanStyle(
    stylesParams.CART_ITEM_IMAGE_VISIBILITY,
    sideCartElementsVisibilityInCss
  );
  const shouldShowItemInfoBySettings = getBooleanStyle(stylesParams.CART_ITEM_INFO, sideCartElementsVisibilityInCss);

  const showPromoCodeBySettings = getBooleanStyle(
    stylesParams.CART_ITEM_PROMO_CODE_VISIBILITY,
    sideCartElementsVisibilityInCss
  );

  return (
    <div>
      {shouldRenderEmptyState ? (
        <div className={classes.emptyState}>
          <Text data-hook={BodyDataHooks.emptyState} className={classes.emptyStateText}>
            {getSettingsWithDefaults(settingsParams.CART_EMPTY_CART)}
          </Text>
        </div>
      ) : (
        <>
          <CartItems
            onRemoveItem={onRemoveItem}
            hideLastDivider={true}
            showQuantityBySettings={showQuantityBySettings}
            showThumbnailBySettings={showThumbnailBySettings}
            shouldShowItemInfoBySettings={shouldShowItemInfoBySettings}
            quantityClassName={sideCartElementsVisibilityInCss ? classes.quantityVisibility : undefined}
            thumbnailClassName={sideCartElementsVisibilityInCss ? classes.imageVisibility : undefined}
            infoClassName={sideCartElementsVisibilityInCss ? classes.infoVisibility : undefined}
          />
          {sideCartCouponAndNote && showPromoCodeBySettings && (
            <>
              <Divider className={classes.divider} data-hook={BodyDataHooks.divider} />
              <div className={classes.linksWrapper}>
                <Coupon textButtonSettingKey={settingsParams.SIDE_CART_ADD_PROMO_CODE_LINK} />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
